<mat-form-field
  appearance="outline"
  class="munily-text-field munily-time-input-field"
  [ngClass]="formFieldClasses"
>
  <mat-label *ngIf="label">
    {{ label }}<span *ngIf="required" class="munily-time-input-field__required-mark">*</span>
  </mat-label>

  <div
    class="munily-time-input-field__time-selects"
    (mousedown)="$event.stopPropagation()"
    (click)="$event.stopPropagation()"
  >
    <mat-select
      class="munily-time-input-field__time-part munily-time-input-field__time-part--hour"
      [placeholder]="'HH'"
      [formControl]="hourCtrl"
      [panelClass]="'munily-time-input-field__time-panel munily-time-input-field__hour-panel'"
      yPosition="below"
      (click)="$event.stopPropagation()"
      (openedChange)="onSelectOpenedChange('hour', $event)"
      (selectionChange)="onHourSelected()"
    >
      <mat-option *ngFor="let hh of hourOptions" [value]="hh">{{ hh }}</mat-option>
    </mat-select>

    <span class="munily-time-input-field__colon" aria-hidden="true">:</span>

    <mat-select
      #minuteSelect="matSelect"
      class="munily-time-input-field__time-part munily-time-input-field__time-part--minute"
      [placeholder]="'MM'"
      [formControl]="minuteCtrl"
      [panelClass]="'munily-time-input-field__time-panel munily-time-input-field__minute-panel'"
      yPosition="below"
      (click)="$event.stopPropagation()"
      (openedChange)="onSelectOpenedChange('minute', $event)"
    >
      <mat-option *ngFor="let mm of minuteOptions" [value]="mm">{{ mm }}</mat-option>
    </mat-select>
  </div>

  <div
    matSuffix
    class="munily-time-input-field__suffix-container"
    (mousedown)="$event.stopPropagation()"
    (click)="$event.stopPropagation()"
  >
    <mat-icon
      *ngIf="shouldShowError"
      class="munily-tf-icon munily-time-input-field__error-icon material-symbols-rounded"
      aria-hidden="true"
    >
      error
    </mat-icon>
    <div class="munily-time-input-field__vertical-divider" aria-hidden="true"></div>
    <mat-select
      class="munily-time-input-field__meridiem"
      [formControl]="meridiemCtrl"
      [panelClass]="'munily-time-input-field__meridiem-panel'"
      yPosition="below"
      (openedChange)="onSelectOpenedChange('meridiem', $event)"
    >
      <mat-option value="AM">AM</mat-option>
      <mat-option value="PM">PM</mat-option>
    </mat-select>
  </div>

  <mat-error *ngIf="shouldShowError && firstErrorMessage">
    {{ firstErrorMessage }}
  </mat-error>
</mat-form-field>
